// @flow

export function getMapValues<T>(dict: {[string]: T}): Array<T> {
  return Object.keys(dict).map((key) => dict[key]);
}
